import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type ReportProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function ReportIcon({
  className,
  pathClassName = "stroke-gray-800",
  ...props
}: ReportProps) {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      {...props}
      className={className}
      fill="none"
    >
      <Path
        d="M6.912 2.975l-5.076 8.796a1.257 1.257 0 001.09 1.884h10.151a1.257 1.257 0 001.09-1.884L9.09 2.975a1.257 1.257 0 00-2.178 0zM7.996 5.053v4.184"
        stroke="#2C7A7B"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
      <Path
        d="M8.03 11.55h-.007"
        stroke="#000"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default ReportIcon;
